module.exports = __webpack_public_path__ + "media/images/red_flag-ca2cb32ca599e38e6cd99f22c14206e9.png";